import { all } from "redux-saga/effects";
import { saga as getManifestacoesGeojson } from "./actions/getManifestacoesGeojson";
import { saga as getTipoManifestacao } from "./actions/getTipoManifestacao";
import { saga as criarManifestacao } from "./actions/criarManifestacao";
import { saga as obterManifestacaoPorId } from "./actions/obterManifestacaoPorId";
import { saga as adicionarMensagem } from "./actions/adicionarMensagem";
import { saga as encerrarManifestacao } from "./actions/encerrarManifestacao";

export default all([
  getManifestacoesGeojson,
  getTipoManifestacao,
  criarManifestacao,
  obterManifestacaoPorId,
  adicionarMensagem,
  encerrarManifestacao
]);
